import NoticeGlobal from 'snippets/notice-global/notice-global'
import register from 'preact-custom-element'

import LazyLoad from 'vanilla-lazyload'

import 'flickity'
import 'flickity/dist/flickity.min.css'

import 'styles/theme.css'

import '@/components/libs/helpers/customer'

import 'snippets/visibility/visibility'
import 'snippets/scroll-direction/scroll-direction'
import 'snippets/key-look/key-look-drawer'
import 'snippets/modal/modal'
import 'snippets/in-view/in-view'
import 'snippets/forms/custom-form'
import 'snippets/lightbox/lightbox'
import 'snippets/flickity/flickity'

import 'snippets/transition/transition'

import 'snippets/auto-scroll/auto-scroll'
import 'snippets/scroller/scroller'
import 'snippets/product/product-selector'

import 'libs/searchspring/searchspring-init'
import 'libs/omneo/omneo-init'

import 'libs/helpers/brauz'

import { WishlistStorage } from 'snippets/wishlist/wishlist-storage'
import 'snippets/wishlist/wishlist-items'
import 'snippets/product/product-quantity'
import 'snippets/product/product-size-guide'
import 'snippets/product/character-limit'
import 'snippets/test-form/test-form'
import 'snippets/test-form/profile-page'
import 'libs/omneo/components/AccountSignUp'

import 'snippets/product/omneo-wishlist'

import { cart } from '../helpers/cart'
import { session } from '../helpers/session'
import { scrollHistoryManager } from '../helpers/scroll-history'

import 'snippets/account/account'

import 'snippets/wishlist/selected'
import 'snippets/wishlist/wishlist-header'
import 'libs/helpers/product'
import 'libs/helpers/touch-hover'
import { dataTracker } from '../snippets/analytics/analytics'
import '../helpers/modal-handler'

import 'snippets/datalayer/bc-datalayer-helper'

window.dataTracker = dataTracker

register(NoticeGlobal, 'notice-global')

window.Cart = cart
window.Session = session
window.lazyLoadInstance = new LazyLoad()
window.scrollHistoryManager = scrollHistoryManager

window.addEventListener(
  'LazyLoad::Initialized',
  function (e) {
    console.log(e.detail.instance)
  },
  false
)

window.lazyLoadInstance.update()
